import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../context/user";
import BoothMark from "./booth/BoothMark";
import "../styles/mainBar.css";

function MainBar({ onAccountClick, showAccount }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const user = useUser();
  const menuRef = useRef(null);

  useEffect(() => {
    if (!menuOpen) return;

    const handlePointerDown = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    const handleKeyDown = (event) => {
      if (event.key === "Escape") setMenuOpen(false);
    };

    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [menuOpen]);

  return (
    <header className="booth-appbar">
      <div className="booth-appbar-inner">
        <a
          href="/"
          className="booth-appbar-mark"
          onClick={(e) => {
            e.preventDefault();
            navigate("/");
          }}
        >
          <BoothMark />
        </a>
        <div className="booth-appbar-account" ref={menuRef}>
          <button
            type="button"
            className={`booth-appbar-account-trigger ${
              showAccount || menuOpen ? "booth-appbar-account-trigger--active" : ""
            }`}
            aria-haspopup="menu"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((open) => !open)}
          >
            Account
          </button>
          {menuOpen && (
            <div className="booth-appbar-menu" role="menu">
              <button
                type="button"
                role="menuitem"
                className="booth-appbar-menu-item"
                onClick={() => {
                  onAccountClick();
                  setMenuOpen(false);
                }}
              >
                Account
              </button>
              <button
                type="button"
                role="menuitem"
                className="booth-appbar-menu-item"
                onClick={async () => {
                  setMenuOpen(false);
                  await user.logout();
                  navigate("/auth");
                }}
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default MainBar;
